import SyncDeviceModal from './SyncDeviceModal';
export default SyncDeviceModal;
